<template>
  <div>
    <v-row class="mt-n3">
      <v-col cols="6">
        <CommonDropDowns class="mt-n3 mr-1" :isItTaxYearWithoutAllYears=true
        @change="dataFromCommonDropDowns" :taxYearValue="editedItem.taxYear"
        :isTaxYearWithoutAllDisabled="true"/>
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pt-0 pb-0" v-model="editedItem.taxId" label="Tax ID"
        readonly tabindex="-1" />
      </v-col>
    </v-row>
    <CommonDropDowns
      id="taxFeesTableDialogFeeDropdown"
      class="tax-fees-table-dialog-fee-dropdown"
      :isItTaxFee="true"
      :taxFeeRequired="true"
      @change="dataFromCommonDropDowns"
      :taxFeeNumValue="editedItem.feeNumber"
      :isTaxFeesDisabled="editedItem.isPaid"
    />
    <v-text-field
      outlined
      class="input-text-size pa-0 mb-n5 tax-fees-table-dialog-fee-amount-field"
      id="taxFeesTableDialogFeeAmountField"
      label="Fee Amount"
      v-model="editedItem.feeAmount"
      @blur="roundAmount"
      :readonly="editedItem.isPaid"
      :tabindex="editedItem.isPaid ? -1 : 0"
      @focus="amountToNum(), $event.target.select()"
      :rules="rules"
    />
    <ClarionDateControl
      class="input-text-size pa-0 tax-fees-table-dialog-effective-date-control"
      id="taxFeesTableDialogEffectiveDateControl"
      label="Effective Date"
      v-model="editedItem.effectiveDate"
      :isToggle="false"
      :isDisabled="editedItem.isPaid"
    />
    <template v-if="!hidePaymentsInformation">
    <v-divider></v-divider>
    <p class="input-text-size mt-3 text-center">Payments Information</p>
    <v-row>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0"
        v-model="editedItem.fiscalYear" label="FY" readonly tabindex="-1"/>
      </v-col>
      <v-col cols="6">
        <v-text-field class="input-text-size pa-0"
        v-model="editedItem.paymentNumber" readonly tabindex="-1" label="Payment Number"/>
      </v-col>
      </v-row>
    <ClarionDateControl v-model="editedItem.paymentDate" :isToggle="false"
     :isDisabled="true" label="Payment Date" class="input-text-size pa-0"/>
    </template>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';

export default {
  name: 'TaxFeesTableDialog',
  components: {
    ClarionDateControl,
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'TaxFeesTableDialog',
    },
    hidePaymentsInformation: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    rules() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    // A paid fee is readonly rather than disabled now, so it can still take focus on a click and
    // these two formatters will fire on it. They rewrite editedItem.feeAmount, so bail out on a
    // paid fee and leave the stored value exactly as it was read.
    roundAmount() {
      if (this.editedItem.isPaid) return;
      this.editedItem.feeAmount = amountFormat(amountToNumber(this.editedItem.feeAmount));
    },
    amountToNum() {
      if (this.editedItem.isPaid) return;
      this.editedItem.feeAmount = amountToNumber(this.editedItem.feeAmount);
    },
  },
};
</script>
